import React from 'react';
import Logo from '../common/Logo';

interface ContributorHighlight {
  name: string;
  label: string;
  amount: number;
}

interface Props {
  highlights: {
    first?: ContributorHighlight;
    top?: ContributorHighlight;
    recent?: ContributorHighlight;
  };
}

const ContributionSidebar: React.FC<Props> = ({ highlights }) => {
  const contributors = Object.values(highlights).filter(Boolean);

  return (
    <div className="mt-6 space-y-4">
      {contributors.map((contrib, idx) => (
        <div key={idx} className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center border">
            <Logo size="small" />
          </div>
          <div>
            <p className="text-sm text-textPrimary font-medium">{contrib.name}</p>
            <p className="text-xs text-gray-500">
              ${contrib.amount.toLocaleString()} · <span className="underline">{contrib.label}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContributionSidebar;
